import { useState, useEffect } from 'react';
import { COOKIES_CONFIG } from '@belong/common';
import { Text } from '@belong/ui';
import clsx from 'clsx';
import { parseCookies } from 'nookies';
import css from './referral-message.module.css';
import { REFERRAL_MESSAGE_STRINGS } from './strings';

const { REFERRAL_USER } = COOKIES_CONFIG;

const fadeTime = 10000;

export function ReferralMessage() {
  const cookies = parseCookies();
  const userName = cookies[REFERRAL_USER.name];
  const [fadeClass, setFadeClass] = useState('');

  useEffect(() => {
    setFadeClass(css.fadeIn!);
    const timer1 = setTimeout(() => setFadeClass(css.fadeOut!), fadeTime);

    return () => {
      clearTimeout(timer1);
    };
  }, []);

  // This flag '-1' is setted when the HO came from a referral link, but the referral user is no longer in Belong.
  // This cookie es needed every time a user uses a referral link, regardless of the response.
  if (!userName || userName !== '-1') return null;

  return (
    <div
      className={clsx(
        'bg-dark-navy p-sm fixed flex items-center justify-center rounded',
        css.messageBox,
        fadeClass,
      )}
    >
      <Text fontWeight="semibold" className="text-white">
        {REFERRAL_MESSAGE_STRINGS['message.notfound']}
      </Text>
    </div>
  );
}
